import axios from 'axios';
import api from './api';

const API_BASE_URL = (process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000').trim().replace(/\/$/, '');

// Staff side (signed in)
export const interviewsAPI = {
  list: () => api.get('/api/interviews'),
  amrSearch: (q) => api.get('/api/interviews/amr/search', { params: { q } }),
  amrArtist: (aid) => api.get(`/api/interviews/amr/artists/${aid}`),
  create: (data) => api.post('/api/interviews', data),
  get: (id) => api.get(`/api/interviews/${id}`),
  update: (id, data) => api.patch(`/api/interviews/${id}`, data),
  remove: (id) => api.delete(`/api/interviews/${id}`),
  research: (id) => api.post(`/api/interviews/${id}/research`),
  saveBrief: (id, brief) => api.patch(`/api/interviews/${id}/brief`, brief),
  invite: (id, channels) => api.post(`/api/interviews/${id}/invite`, { channels }),
  generateFollowups: (id) => api.post(`/api/interviews/${id}/followups/generate`),
  saveFollowups: (id, list) => api.put(`/api/interviews/${id}/followups`, list),
  sendFollowups: (id) => api.post(`/api/interviews/${id}/followups/send`),
  compile: (id) => api.post(`/api/interviews/${id}/compile`),
  toDesk: (id, note) => api.post(`/api/interviews/${id}/desk`, { note }),
  cancelDesk: (id) => api.post(`/api/interviews/${id}/desk/cancel`),
  savePackage: (id, pkg) => api.put(`/api/interviews/${id}/package`, pkg),
  approve: (id) => api.post(`/api/interviews/${id}/approve`),
  unapprove: (id) => api.post(`/api/interviews/${id}/unapprove`),
  pdf: (id) => api.get(`/api/interviews/${id}/pdf`, { responseType: 'blob' }),
  exportJson: (id) => api.get(`/api/interviews/${id}/export`),
  audio: (id, sessionId) => api.get(`/api/interviews/${id}/audio/${sessionId}`, { responseType: 'blob' }),
  file: (id, fileId) => api.get(`/api/interviews/${id}/files/${fileId}`, { responseType: 'blob' }),
};

// Person's side (no login; the token in the link is the key)
const pub = axios.create({ baseURL: API_BASE_URL });

export const interviewPublicAPI = {
  get: (token) => pub.get(`/api/interview-public/${token}`),
  chat: (token, message) => pub.post(`/api/interview-public/${token}/chat`, { message }),
  finish: (token) => pub.post(`/api/interview-public/${token}/finish`),
  answer: (token, answers) => pub.post(`/api/interview-public/${token}/followups`, { answers }),
  upload: (token, key, file) => {
    const fd = new FormData();
    fd.append('file', file);
    return pub.post(`/api/interview-public/${token}/followups/${key}/upload`, fd);
  },
  consent: (token, data) => pub.post(`/api/interview-public/${token}/consent`, data),
  pkg: (token) => pub.get(`/api/interview-public/${token}/package`),
  pdfUrl: (token) => `${API_BASE_URL}/api/interview-public/${token}/pdf`,
  voiceUrl: (token) => `${API_BASE_URL.replace(/^http/, 'ws')}/api/interview-public/${token}/voice`,
};

// Downloads a blob response as a file
export const saveBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
};
